import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button } from './Button';
import { getSubscription } from '../store/selectors';
import flashMessageTypes from '../constants/flashMessageTypes';
import subscriptionStatus from '../constants/subscriptionStatus';
import { doFetchSubscription } from '../store/actions';

const ReturnButtonWrapper = styled.div`
  width: 100%;
`;

class ReturnButton extends Component {
  onButtonClick = e => {
    e.preventDefault();
    this.props.onFetchSubscription();
  };

  render() {
    const { type, subscription, onCloseClick, modal } = this.props;

    return (
      <ReturnButtonWrapper>
        {type === flashMessageTypes.success ? (
          <Button onClick={modal ? this.onButtonClick : e => onCloseClick(e, true)}>
            Voltar para a tela inicial
          </Button>
        ) : (
          <>
            <Button onClick={e => onCloseClick(e, true)}>Tentar novamente</Button>
            {subscription.status === subscriptionStatus.ATIVA ? (
              <Button onClick={this.onButtonClick} noBorder>
                Voltar para a tela inicial
              </Button>
            ) : null}
          </>
        )}
      </ReturnButtonWrapper>
    );
  }
}

ReturnButton.propTypes = {
  type: PropTypes.string.isRequired,
  subscription: PropTypes.object.isRequired,
  onFetchSubscription: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  subscription: getSubscription(state),
});

const mapDispatchToProps = dispatch => ({
  onFetchSubscription: () => dispatch(doFetchSubscription()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ReturnButton));
